// extracted by mini-css-extract-plugin
export var integrationButton = "_6h-0";